import React from 'react';
import SeoLandingPage from '../components/SeoLandingPage';

const PageFrontaliersSuisse = () => (
  <SeoLandingPage
    slug="conseiller-patrimonial-frontaliers-suisse"
    title="Conseiller patrimonial frontaliers Suisse - Annecy & Genève - Arthur Vacogne"
    description="Conseiller en gestion de patrimoine spécialisé frontaliers Suisse à Annecy et Genève. Optimisation fiscalité franco-suisse, 2e pilier LPP, 3e pilier, préparation retraite. Bilan offert."
    keywords="conseiller frontalier Suisse, gestion patrimoine frontalier Genève, conseiller financier frontalier Annemasse, 2e pilier LPP, 3e pilier, retour France frontalier, rachat 2e pilier, optimisation fiscalité franco-suisse, frontalier Saint-Julien-en-Genevois"
    h1="Conseiller patrimonial spécialisé frontaliers Suisse"
    subtitle="Vivre en France et travailler en Suisse offre de belles opportunités… mais aussi des complexités fiscales et patrimoniales uniques : LPP, 3e pilier, fiscalité franco-suisse, retour en France, retraite. En tant que conseiller indépendant basé à Annecy, j'accompagne les frontaliers sur tous ces sujets."
    schemaService="Conseil patrimonial pour frontaliers Suisse (Annecy, Genève, Annemasse, Saint-Julien)"
    sections={[
      {
        title: "Frontalier Suisse : les enjeux patrimoniaux spécifiques",
        body: "En tant que frontalier travaillant en Suisse, votre situation patrimoniale est doublement complexe : vous cotisez à un système de retraite suisse (1er, 2e et 3e pilier) tout en résidant fiscalement en France. Plusieurs sujets doivent être anticipés pour ne pas subir une fiscalité élevée à la retraite ou en cas de retour en France.",
        bullets: [
          "Optimisation de la fiscalité franco-suisse (CHF vs €, imposition à la source)",
          "Gestion du 2e pilier (LPP) : retrait, rente ou capital ?",
          "3e pilier (épargne retraite suisse) : avantages et limites",
          "Prévoyance individuelle complémentaire en France",
          "Préparation du retour en France et planification successorale"
        ]
      },
      {
        title: "Le 2e pilier LPP : retrait, rente ou mix ?",
        body: "À la retraite ou lors d'un retour définitif en France, vous devez décider du sort de votre 2e pilier (LPP). Trois options principales : retrait en capital, rente viagère, ou combinaison des deux. Chaque choix a des conséquences fiscales majeures en France comme en Suisse.",
        bullets: [
          "Retrait en capital : imposition unique en Suisse (~5-10%), placement libre ensuite",
          "Rente viagère : versement régulier, imposition annuelle en France",
          "Mix capital/rente : optimisation possible selon votre situation",
          "Cas particulier du retour en France avant la retraite : déblocage anticipé"
        ]
      },
      {
        title: "Rapatriement du capital : que faire de votre LPP en France ?",
        body: "Une fois votre 2e pilier rapatrié en France, plusieurs solutions s'offrent à vous pour réinvestir ce capital de manière fiscalement avantageuse et générer des revenus complémentaires à la retraite.",
        bullets: [
          "Assurance vie luxembourgeoise : protection et fiscalité avantageuse",
          "SCPI : revenus immobiliers passifs",
          "PER (Plan Épargne Retraite) : déduction fiscale et complément retraite",
          "Investissement immobilier locatif en France",
          "Donation aux enfants : optimisation successorale anticipée"
        ]
      },
      {
        title: "Frontaliers Genevois : les villes où j'interviens",
        body: "Basé à Annecy-le-Vieux, j'accompagne les frontaliers Suisse de toute la zone Genevois et bassin lémanique, en rendez-vous physique ou en visio selon vos disponibilités.",
        bullets: [
          "Annemasse, Gaillard, Vétraz-Monthoux, Ambilly, Ville-la-Grand",
          "Saint-Julien-en-Genevois, Archamps, Collonges-sous-Salève",
          "Reignier-Ésery, Bonneville, La Roche-sur-Foron",
          "Bons-en-Chablais, Douvaine, Sciez, Thonon-les-Bains",
          "Évian-les-Bains, Publier, Lugrin",
          "Ferney-Voltaire, Saint-Genis-Pouilly, Gex, Divonne-les-Bains",
          "Annecy et Annecy-le-Vieux"
        ]
      }
    ]}
    faq={[
      { q: "Faut-il déclarer son LPP en France ?",
        a: "Oui. Tout résident fiscal français doit déclarer ses avoirs détenus à l'étranger, y compris son 2e pilier suisse. Cependant, la convention fiscale franco-suisse prévoit que les prestations soient imposées en Suisse lors du retrait, évitant la double imposition." },
      { q: "Quelle est la meilleure stratégie pour préparer ma retraite en tant que frontalier ?",
        a: "La stratégie optimale combine généralement : (1) maximisation du 2e pilier LPP (rachats annuels si possible), (2) ouverture d'une assurance vie en France pour la flexibilité, (3) éventuellement un PER pour la déduction fiscale, (4) un investissement immobilier locatif en France. Le mix précis dépend de votre âge, votre projet de retraite et votre TMI." },
      { q: "Que se passe-t-il pour mon LPP si je rentre définitivement en France avant la retraite ?",
        a: "Vous pouvez demander un retrait anticipé de votre 2e pilier LPP en capital. Le retrait est imposé en Suisse selon un barème spécifique (5-15% selon le canton et le montant). Ce capital peut ensuite être réinvesti librement en France." },
      { q: "Combien coûtent vos conseils pour les frontaliers Suisse ?",
        a: "Le bilan patrimonial est entièrement offert et sans engagement. Aucun honoraire client n'est facturé. La rémunération s'effectue uniquement auprès des partenaires fournisseurs de solutions." }
    ]}
  />
);

export default PageFrontaliersSuisse;
